import { ReactNode, useState, SyntheticEvent } from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Chip from '@mui/material/Chip';

function getTags(text: string) {
  const tags = text.split(',').filter((t) => t).map((t) => t.trim());
  return tags;
}

function getText(tags: string[]) {
  return tags.join(',');
}

interface ChipInputChange {
  name?: string | undefined;
  value: string[];
}

interface ChipInputProps {
  label?: ReactNode;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  required?: boolean;
  onChange?: (event: SyntheticEvent, change: ChipInputChange) => void;
  value: string[];
  name?: string;
  error?: boolean;
  disabled?: boolean;
  getLocked?: (tag: string, index: number) => boolean;
}

export default function ChipInput(props: ChipInputProps) {
  const {
    label,
    fullWidth,
    sx,
    required,
    onChange,
    value,
    name,
    error,
    disabled,
  } = props;

  const [text, setText] = useState('');
  const [editMode, setEditMode] = useState(false);

  const getLocked = (props.getLocked || (() => false));

  const handleChange = (e: SyntheticEvent, tags: ChipInputChange) => {
    if (!onChange) {
      return;
    }
    onChange(e, tags);
  };

  return (
    <FormControl {... { fullWidth, sx }}>
      <InputLabel htmlFor="outlined-adornment-amount">{label}</InputLabel>
      <OutlinedInput
        {...{ required, label }}
        fullWidth
        label={label}
        name={name}
        error={error}
        size="small"
        value={editMode ? text : ''}
        onChange={(e) => {
          setText(e.target.value);
        }}
        disabled={disabled}
        startAdornment={(
          <InputAdornment sx={{ mr: 0 }} position="start">
            {
              !editMode && value.map((t, idx) => (
                <Chip
                  key={idx}
                  size="small"
                  sx={{ mr: 0.5 }}
                  label={t}
                  onDelete={getLocked(t, idx)
                    ? undefined
                    : (e) => {
                      value.splice(idx, 1);
                      handleChange(e, {
                        name,
                        value,
                      });
                    }}
                />
              ))
            }
          </InputAdornment>
        )}
        inputProps={{
          onFocus: (_e) => {
            setText(getText(value));
            setEditMode(true);
          },
          onBlur: (e) => {
            setEditMode(false);
            const tags = getTags(e.target.value);
            handleChange(e, {
              name,
              value: tags,
            });
          },
        }}

      />
    </FormControl>
  );
}
